import { Link, useParams } from 'react-router-dom';
import { ChevronDown, LogOut, Server } from 'lucide-react';
import { useAuth } from '@/lib/auth/useAuth';

/**
 * Real guild lookup (Batch 5) — resolves the current :guildId against the
 * authenticated user's real guild list from AuthProvider, rather than
 * showing the raw URL param. Falls back to the raw ID for the
 * unauthenticated "preview-server" placeholder flow, which intentionally
 * has no real guild behind it.
 */
export function TopBar() {
  const { guildId } = useParams<{ guildId: string }>();
  const { status, user, guilds, logout } = useAuth();

  const currentGuild = guilds.find((g) => g.id === guildId);
  const label = currentGuild?.name ?? guildId ?? 'No server selected';

  return (
    <header className="h-14 flex items-center justify-between px-4 border-b border-border-subtle bg-bg-surface md:bg-transparent">
      <Link
        to="/dashboard"
        className="flex items-center gap-2 min-h-[44px] px-2.5 rounded-sm border border-border-subtle text-text-secondary text-small hover:border-border hover:text-text-primary transition-colors"
      >
        {currentGuild?.icon ? (
          <img
            src={`https://cdn.discordapp.com/icons/${currentGuild.id}/${currentGuild.icon}.png?size=32`}
            alt=""
            className="h-4 w-4 rounded-full"
          />
        ) : (
          <Server size={16} aria-hidden="true" />
        )}
        <span className="max-w-[10rem] truncate">{label}</span>
        <ChevronDown size={14} aria-hidden="true" />
      </Link>

      {status === 'authenticated' && user ? (
        <button
          type="button"
          onClick={() => void logout()}
          className="flex items-center gap-2 min-h-[44px] min-w-[44px] justify-center text-text-secondary hover:text-text-primary text-small"
          aria-label="Sign out"
        >
          {user.avatar ? (
            <img
              src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png?size=32`}
              alt=""
              className="h-6 w-6 rounded-full"
            />
          ) : null}
          <LogOut size={16} aria-hidden="true" />
        </button>
      ) : null}
    </header>
  );
}
